// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aip-supplement-notam-system.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aip-supplement-notam-system/aip-supplement-notam-system.js';

mount([g0]);
